import React, { useState } from "react";
import * as Const from "../Const";
import EmailInput from "./EmailInput";
import PasswordInput from "./PasswordInput";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Card } from "react-bootstrap";

function UserRegistrationTab() {

    const emailRegExp = /\S+@\S+\.\S+/;

    const navigation = useNavigate();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [password2, setPassword2] = useState("");
    const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);

    const handleEmailChange = (value) => {
        setEmail(value);
    };


    const handlePasswordChange = (value) => {
        setPassword(value);
    };

    function _isPasswordValid(value) {
        return value ? value.length >= 8 : null;
    }

    const handlePassword2Change = (value) => {
        setPassword2(value);
    };

    const isEmailValid = email ? email.match(emailRegExp) !== null : null;
    const isInputValid = isEmailValid && _isPasswordValid(password) && _isPasswordValid(password2) && (password === password2);


    const handleSubmit = (event) => {
        event.preventDefault();
        // validateForm();

        if (isInputValid && !isSubmitDisabled) {
            const data = {
                email: email,
                password: password,
            };

            setIsSubmitDisabled(true);

            axios
                .post(Const.API_CLOUD_USERS, data)
                .then((res) => {
                    console.log(res);
                    if (res.status === 201) {
                        const userId = res.headers.location.split("/").at(-1);
                        console.log("new user id " + userId);
                        navigation(Const.BASE_NAME + "/user/confirm/" + userId);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    const res = error.response;
                    if (res.status === 409) {
                        navigation(Const.BASE_NAME + "/user/confirm");
                    } else {
                        navigation("/");
                    }
                });
        }
    };



    return (
        <Card>
            <Card.Header>Register Account</Card.Header>
            <Card.Body>
                <form className="row g-3 align-items-start" method={"post"}>
                    <div className={"col-12 col-lg-4"}>
                        <EmailInput
                            email={email}
                            onChange={handleEmailChange}
                            isValid={isEmailValid}
                        />
                    </div>
                    <div className={"col-12 col-lg-3"}>
                        <PasswordInput
                            name={"password"}
                            placeholder={"Password"}
                            onChange={handlePasswordChange}
                            isValid={_isPasswordValid(password)}
                        />
                    </div>
                    <div className={"col-12 col-lg-3"}>
                        <PasswordInput
                            name={"password2"}
                            placeholder={"Repeat Password"}
                            onChange={handlePassword2Change}
                            isValid={_isPasswordValid(password2) && password === password2}
                        />
                    </div>
                    <div className={"col-12 col-lg-2"}>
                        <button
                            className={"btn btn-primary w-100"}
                            type={"submit"}
                            onClick={handleSubmit}
                            disabled={!isInputValid || isSubmitDisabled}
                        >
                            Submit
                        </button>
                    </div>
                </form>
            </Card.Body>

            <Card.Footer>
                <div className={"row justify-content-center"}>
                    <div className={"col-12 col-lg-4"}>
                        <a
                            className={"btn btn-secondary w-100"}
                            href={Const.BASE_NAME + "/user/confirm"}
                        >
                            Enter Validation Code
                        </a>
                    </div>
                    <div className={"col-12 col-lg-4"}>
                        <a
                            className={"btn btn-secondary w-100"}
                            href={Const.BASE_NAME + "/user/login"}
                        >
                            Go to Login
                        </a>
                    </div>
                </div>
            </Card.Footer>
        </Card>
    );
}

export default UserRegistrationTab;